export type ClassContentType =
  | 'CHARACTER_PILLAR'
  | 'MISSION'
  | 'LEARNING_LECTURE'
  | 'HOME_ACTIVITY';

export interface ClassActivityAssignment {
  id: string;
  schoolId: string;
  classId: string;
  contentType: ClassContentType;
  contentId: string;
  characterPillarId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ClassContentSelection {
  characterPillarIds: string[];
  missionIds: string[];
  learningLectureIds: string[];
  homeActivityIds: string[];
}

export type ReplaceClassActivityAssignmentsInput = ClassContentSelection;

export const EMPTY_CLASS_CONTENT_SELECTION: ClassContentSelection = {
  characterPillarIds: [],
  missionIds: [],
  learningLectureIds: [],
  homeActivityIds: []
};

export function selectionFromAssignments(
  assignments: ClassActivityAssignment[]
): ClassContentSelection {
  return {
    characterPillarIds: assignments
      .filter((item) => item.contentType === 'CHARACTER_PILLAR')
      .map((item) => item.contentId),
    missionIds: assignments
      .filter((item) => item.contentType === 'MISSION')
      .map((item) => item.contentId),
    learningLectureIds: assignments
      .filter((item) => item.contentType === 'LEARNING_LECTURE')
      .map((item) => item.contentId),
    homeActivityIds: assignments
      .filter((item) => item.contentType === 'HOME_ACTIVITY')
      .map((item) => item.contentId)
  };
}
